import React, { useContext } from 'react';
import { Box, Checkbox, FormControlLabel, Stack } from '@mui/material';
import {
  MdClose,
  MdOutlineLocalAirport,
  MdLocalShipping
} from 'react-icons/md';
import { useModal } from '../../../../hooks/Modal';
import { usePickup } from '../../../../hooks/Pickup';

import { DefaultCollectContext } from '../..';
import {
  CloseModalButton,
  ModalTitle,
  OrientationTitle,
  OrientationImg,
  OrientationDescription,
  Text
} from './styled';

import { transport } from '../../../../assets/transport';

export const ModalAcceptTransportTerms = () => {
  const { closeModal, Modal } = useModal();
  const { customerAcceptGuidelines, setCustomerAcceptGuidelines } = usePickup();

  const { transportSelectedToModal, checkListSelected } = useContext(
    DefaultCollectContext
  );

  const isChecked = (check) => {
    if (check === true) {
      setTimeout(() => {
        setCustomerAcceptGuidelines(true);
        closeModal();
      }, 500);
    } else {
      closeModal();
    }
  };

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          maxWidth: '86vw',
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <CloseModalButton
          data-testid="closeAcceptTransportTermsModal"
          onClick={handleCloseModal}
        >
          <MdClose />
        </CloseModalButton>

        {transportSelectedToModal === 1 ? (
          <ModalTitle style={{ color: 'blue' }}>
            <MdLocalShipping />
            <Text>RODOVIÁRIO BRASPRESS</Text>
            <MdLocalShipping />
          </ModalTitle>
        ) : (
          <ModalTitle style={{ color: 'blue' }}>
            <MdOutlineLocalAirport />
            <Text>RODOAÉREO BRASPRESS</Text>
            <MdOutlineLocalAirport />
          </ModalTitle>
        )}

        <Stack direction="row" spacing={8}>
          <Stack spacing={2} alignItems="center">
            <OrientationTitle>Embalagem:</OrientationTitle>
            <OrientationImg src={transport.transport01} alt="Embalagem" />
            <OrientationDescription>
              {checkListSelected?.packageDescription}
              {/* Mercadorias devem estar devidamente embaladas em caixa de papelão. */}
            </OrientationDescription>
          </Stack>
          <Stack spacing={2} alignItems="center">
            <OrientationTitle>Peso:</OrientationTitle>
            <OrientationImg src={transport.transport02} alt="Peso" />
            <OrientationDescription>
              {checkListSelected?.weightDescription}
              {/* Não pode ultrapassar de 70kg por volume, caso ultrapasse será
              analisado por uma equipe */}
            </OrientationDescription>
          </Stack>
          <Stack spacing={2} alignItems="center">
            <OrientationTitle>Medidas:</OrientationTitle>
            <OrientationImg src={transport.transport03} alt="Medidas" />
            <OrientationDescription>
              {checkListSelected?.measureDescription}
              {/* Não pode ultrapassar de 120 centímetros, caso ultrapasse será
              analisado por uma equipe. */}
            </OrientationDescription>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          spacing={1}
          style={{
            borderTop: '1px solid #888888',
            paddingTop: 8,
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: 16
          }}
        >
          <FormControlLabel
            label="Li as informações e estou ciente"
            name="acceptTermsModal"
            style={{ color: '#004e9a' }}
            control={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Checkbox
                checked={customerAcceptGuidelines}
                onChange={(e) => isChecked(e.target.checked)}
                // checked={customerAcceptGuidelines}
              />
            }
          />
        </Stack>
      </Box>
    </Modal>
  );
};
